module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-3"
    }
  }, [_c('strong', [_c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_vm._v("ABBREVIATIONS")])])]), _c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BSac")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Bibliotheca Sacra")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CBQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Catholic Biblical Quarterly")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CO")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Calvini Opera — Corpus Reformatorum")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Comm.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Calvin’s "), _c('em', [_vm._v("Commentaries")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CR")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Corpus Reformatorum")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CTJ")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Calvin Theological Journal")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CTM")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Concordia Theological Monthly")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CurTM")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Currents in Theology and Mission")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("EvQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Evangelical Quarterly")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ExpT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Expository Times")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("GTJ")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Grace Theological Journal")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("HorBT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Horizons of Biblical Theology")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Int")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Interpretation")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ISBE")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("International Standard Bible Encyclopedia")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JETS")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of the Evangelical Theological Society")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JSOT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal for the Study of the Old Testament")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("LuthQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Lutheran Quarterly")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("LW")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Luther’s Works —")]), _vm._v(" American Edition")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("NGTT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Nederduitse Gereformeerde Teologiese Tydskrif")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("NTS")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("New Testament Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("PG")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Patrologia Graeca")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("PL")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Patrologia Latina")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("RevExp")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Review and Expositor")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("SJT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Scottish Journal of Theology")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TDNT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Theological Dictionary of the New Testament")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Th")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Theology")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TynBul")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Tyndale Bulletin")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("WA")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Weimarer Ausgabe,")]), _vm._v(" Luther’s "), _c('em', [_vm._v("Werke")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("WTJ")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Westminster Theological Journal")]), _c('a', {
    attrs: {
      "id": "page_xviii"
    }
  })])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6692bdbb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/007_Abbreviations.vue
// module id = 75
// module chunks = 0